// extracted by mini-css-extract-plugin
module.exports = {"ctn":"prize_ctn__1TNZB","imgBox":"prize_imgBox__UuZcw","winnersThree":"prize_winnersThree__2Otdw","masterBundleImg":"prize_masterBundleImg__3wXmu"};